import React from 'react';
import { colors } from '../../utils/constants';

const ServiceVenturesLogo = ({ size = 'medium' }) => {
  const dimensions = size === 'small' ? 24 : size === 'large' ? 48 : 32;
  
  return (
    <div className="relative" style={{ width: dimensions, height: dimensions }}>
      <svg width={dimensions} height={dimensions} viewBox="0 0 100 100" className="transform rotate-45">
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: colors.lightBlue }} />
            <stop offset="50%" style={{ stopColor: colors.blue }} />
            <stop offset="100%" style={{ stopColor: colors.navyBlue }} />
          </linearGradient>
        </defs>
        <polygon points="50,10 90,50 50,90 10,50" fill="url(#gradient1)" />
        <polygon points="50,10 90,50 50,50" fill={colors.lightBlue} opacity="0.8" />
        <polygon points="10,50 50,50 50,90" fill={colors.navyBlue} opacity="0.9" />
      </svg>
    </div>
  );
};

export default ServiceVenturesLogo;